<template>
  <svg
    version="1.1"
    id="Layer_1"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style="enable-background:new 0 0 512 512;"
    xml:space="preserve"
  >
    <path
      class="st0"
      d="M439,291.3l36.8-162c2.7-11.7-6.2-22.8-18.2-22.8h-306l-7.1-34.9c-1.8-8.7-9.4-14.9-18.3-14.9H46.3
	C36,56.6,27.7,65,27.7,75.3v12.5c0,10.3,8.4,18.7,18.7,18.7h54.4L155.5,374c-13.1,7.5-21.9,21.6-21.9,37.8
	c0,24.1,19.5,43.6,43.6,43.6s43.6-19.5,43.6-43.6c0-12.2-5-23.2-13.1-31.2H371c-8.1,7.9-13.1,18.9-13.1,31.2
	c0,24.1,19.5,43.6,43.6,43.6c24.1,0,43.6-19.5,43.6-43.6c0-17.3-10-32.2-24.6-39.3l4.3-18.9c2.7-11.7-6.2-22.8-18.2-22.8H197.6
	l-5.1-24.9h228.4C429.5,305.9,437.1,299.8,439,291.3z"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
